import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  display: inline-block;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #4682B4 0%, #87CEEB 100%);
  color: #000000;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(70, 130, 180, 0.4);
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.2), transparent);
    transition: left 0.5s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  ${props => props.variant === 'outline' && `
    background: transparent;
    border: 2px solid #4682B4;
    color: #4682B4;
    
    &:hover {
      background: #4682B4;
      color: #000000;
    }
  `}
  
  ${props => props.variant === 'secondary' && `
    background: #1a1a1a;
    color: #ffffff;
    
    &:hover {
      background: #2a2a2a;
      transform: translateY(-2px);
    }
  `}
  
  ${props => props.size === 'small' && `
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  `}
  
  ${props => props.size === 'large' && `
    padding: 1.25rem 2.5rem;
    font-size: 1.125rem;
  `}
`;

const Button = ({ children, variant, size, ...props }) => {
  return (
    <StyledButton variant={variant} size={size} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;
